import { render } from "./wenben.vue?vue&type=template&id=d6954c60&scoped=true"
import script from "./wenben.vue?vue&type=script&lang=js"
export * from "./wenben.vue?vue&type=script&lang=js"

import "./wenben.vue?vue&type=style&index=0&id=d6954c60&scoped=true&lang=css"

import exportComponent from "F:\\MyProject\\8.142.129.201\\FCS\\admin\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6954c60"]])

export default __exports__